import { AppLayout } from "@/components/layout/AppLayout";
import { PageHeader } from "@/components/layout/PageHeader";
import { PageContainer } from "@/components/layout/PageContainer";
import { GuideStepRail } from "@/components/internal/GuideStepRail";
import { GuideSectionBlock } from "@/components/internal/GuideSection";
import { GUIDE_SECTIONS } from "@/pages/internal/userServicesGuideContent";

/**
 * Internal documentation for staff and administrators (non-technical audience).
 */
export default function UserServicesGuidePage() {
  return (
    <AppLayout>
      <PageContainer width="wide">
        <PageHeader
          title="User services guide"
          description="How patrons join your library, how staff approve and issue cards, and how to manage accounts day to day."
          breadcrumbItems={[
            { label: "Dashboard", href: "/dashboard" },
            { label: "User services guide" },
          ]}
          showSearch={false}
          titleSize="md"
        />

        <GuideStepRail />

        <div className="space-y-6">
          {GUIDE_SECTIONS.map((section) => (
            <GuideSectionBlock key={section.id} section={section} />
          ))}
        </div>
      </PageContainer>
    </AppLayout>
  );
}
